// src/styles/animations.js
import { keyframes } from 'styled-components';

// Fade in animation
export const fadeIn = keyframes`
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  `;

// Slide in from bottom animation
export const slideInBottom = keyframes`
    from {
      transform: translateY(30px);
      opacity: 0;
    }
    to {
      transform: translateY(0);
      opacity: 1;
    }
  `;

// Slide in from left animation
export const slideInLeft = keyframes`
    from {
      transform: translateX(-30px);
      opacity: 0;
    }
    to {
      transform: translateX(0);
      opacity: 1;
    }
  `;

// Slide in from right animation
export const slideInRight = keyframes`
    from {
      transform: translateX(30px);
      opacity: 0;
    }
    to {
      transform: translateX(0);
      opacity: 1;
    }
  `;

// Scale in animation for cards
export const scaleIn = keyframes`
    from {
      transform: scale(0.95);
      opacity: 0;
    }
    to {
      transform: scale(1);
      opacity: 1;
    }
  `;

// Float animation for hover effects
export const float = keyframes`
    0% {
      transform: translateY(0px);
    }
    50% {
      transform: translateY(-8px);
    }
    100% {
      transform: translateY(0px);
    }
  `;

// Shine effect for wood texture
export const woodShine = keyframes`
    from {
      background-position: -200px 0;
    }
    to {
      background-position: 200px 0;
    }
  `;